import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";
import { FadeUp, MaskedReveal } from "./Reveal";

const FAQS = [
    {
        q: "Voor wie is MeerjarenplanOnline.nl bedoeld?",
        a: "Voor verenigings- en stichtingsbesturen, maar ook voor accountants, financials, adviseurs en DGA's die investeringsbeslissingen willen onderbouwen. Of het nu gaat om een investeringsaanvraag, een financieringsgesprek of een strategische doorrekening — MeerjarenplanOnline.nl maakt het verschil in snelheid en overtuigingskracht.",
    },
    {
        q: "Welke bestanden kan ik importeren?",
        a: "De AI leest historische cijfers direct uit een PDF van het jaarverslag. De afschrijvingsstaat importeer je in een handomdraai vanuit Excel of PDF. Handmatig overtypen is verleden tijd.",
    },
    {
        q: "Hoe werkt de Monte Carlo simulator?",
        a: "De simulator rekent duizenden varianten van je scenario door en toont de statistische kansen. Je ziet direct de P10–P90 bandbreedte en met de tornadochart welke aannames de grootste invloed hebben op de uitkomst.",
    },
    {
        q: "Kan ik ongelimiteerd scenario's bouwen?",
        a: "Ja. De scenariobouwer werkt ongelimiteerd en snel, op basis van groeiaannames, investeringsplannen, financieringsplannen en inflatie — en toont direct de kasstroom-implicaties.",
    },
    {
        q: "Kan ik MeerjarenplanOnline.nl eerst zien voordat ik beslis?",
        a: "Natuurlijk. Ga naar de prijzenpagina en selecteer de gratis optie — en overtuig jezelf aan de hand van een dataset.",
    },
];

const Faq = () => (
    <section id="faq" data-testid="faq-section" className="bg-[#F9FAFB] py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12">
            <div className="lg:col-span-5">
                <div className="lg:sticky lg:top-32">
                    <FadeUp>
                        <p className="text-xs tracking-[0.25em] uppercase font-bold text-[#0047FF] mb-5">FAQ</p>
                    </FadeUp>
                    <h2 className="font-heading text-[#0A0A0A] font-bold tracking-tight text-4xl sm:text-5xl leading-[1.02]">
                        <MaskedReveal>Veelgestelde</MaskedReveal>
                        <MaskedReveal delay={0.12}>vragen.</MaskedReveal>
                    </h2>
                    <FadeUp delay={0.2} className="mt-6">
                        <p className="text-[#0A0A0A]/60 text-base leading-relaxed max-w-sm">
                            Staat je vraag er niet bij? Start de gratis proefperiode
                            en ontdek het zelf — elke functie werkt.
                        </p>
                    </FadeUp>
                </div>
            </div>
            <div className="lg:col-span-7">
                <FadeUp delay={0.1}>
                    <Accordion type="single" collapsible data-testid="faq-accordion">
                        {FAQS.map((f, i) => (
                            <AccordionItem
                                key={f.q}
                                value={`item-${i}`}
                                data-testid={`faq-item-${i}`}
                                className="border-black/10"
                            >
                                <AccordionTrigger
                                    data-testid={`faq-trigger-${i}`}
                                    className="text-left font-heading font-bold tracking-tight text-lg md:text-xl text-[#0A0A0A] hover:text-[#FF6B00] transition-colors duration-300 py-6"
                                >
                                    {f.q}
                                </AccordionTrigger>
                                <AccordionContent className="text-[#0A0A0A]/60 text-base leading-relaxed pb-6">
                                    {f.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </FadeUp>
            </div>
        </div>
    </section>
);

export default Faq;
